// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S3kJ5","input":"styles_input__38fSA"};